import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function ProductsDropdownNav({closeMobileMenu }) {
  const [open, setOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dropdownRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();

  // Check if current route is a product detail route
  const isProductsRoute = location.pathname.startsWith('/product-detail');

  // Fetch product categories from API
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch('https://grayapi.grayzo.in/api/productCategory');
        const data = await response.json();
        
        if (data.status) {
          setCategories(data.data);
        } else {
          setError('Failed to fetch product categories');
        }
      } catch (err) {
        setError('Error fetching product categories: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close on route change
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleCategoryClick = (category) => {
    const imageBaseUrl = "https://grayapi.grayzo.in/AdminArea/code/image/";
    // navigate(`/subcategory/${category.slug}`, { 
    navigate(`/${category.slug}`, { 
      state: { 
        bannerImage: category.banner_image ? `${imageBaseUrl}${encodeURIComponent(category.banner_image)}` : null 
      } 
    });
    closeMobileMenu();
  };

  return (
    <div className="nav-item dropdown" ref={dropdownRef}>
      <a
        href="#"
        className={`nav-link dropbtn ${isProductsRoute ? "active" : ""}`}
        onClick={(e) => {
          e.preventDefault(); 
          setOpen(!open);
        }}
      >
        Products
      </a>

      <div className={`dropdown-menu m-0 dropdown-content ${open ? "show" : ""}`}>
        {loading ? (
          <div className="dropdown-item">Loading...</div>
        ) : error ? (
          <div className="dropdown-item text-danger">Error loading categories</div>
        ) : (
          categories.map((category) => (
            <a 
              key={category.id} 
              href="#"
              className="dropdown-item" 
              onClick={(e) => {
                e.preventDefault();
                handleCategoryClick(category);
              }}
            >
              {category.service_category.trim()}
            </a>
          ))
        )}
        {/* <a 
            href="#"
            className="dropdown-item" 
            onClick={(e) => {
              e.preventDefault();
              handleCategoryClick({slug:'glass',banner_image:null});
            }}
          >
            Glass
          </a> */}
      </div>
    </div>
  );
}

export default ProductsDropdownNav;
